import React from "react";
import {ErrorPage} from "./ErrorPage";
import {AppWrapper} from "../../commons/components/wrappers/AppWrapper";


export const ErrorApp = () => {

    return (
        <AppWrapper.Default>
            <ErrorPage/>
        </AppWrapper.Default>
    )
};